import { mergeWorkspaceTeams } from "../../../utils/workspaceView";
import * as actionTypes from "./type";
import axios from "axios";
import {
  requestShowLoader,
  requestHiderLoader,
  showToastMsg,
} from "../global/action";

import { REQUEST_FAILED } from "../global/type";
import { getCookie } from "../../../config/cookie";
import {
  deleteGroupFrmGrpDb,
  deleteMsgFromDb,
  getMessageByTempTimetoken,
  addReaderToMessages,
  deleteTempMessageData,
  getAllAcountLevelMember,
  getGroupDMListData,
  getArchiveGroupsData,
  getChatSyncedTo,
  setChatSyncedTo,
  deleteMessagesBefore,
  getMessageFromDb,
  getTempStoreMessageData,
  pruneConfirmedTempMessages,
  deleteGroupLocally,
  replaceMessageAttachments,
  sotreAllAcountLevelMember,
  sotreGroupDMListData,
  storeMessageToDb,
  storeProfileData,
  storeTempMessageToDb,
  updateGroupDMListData,
  updateGroupDMListDataTimetoken,
  updateGroupDMDataMsgCount,
  updateMessageToDb,
  updateArchiveKeyInGroupList,
} from "../../../config/db";
import { UPDATE_PROFILE_DONE, UPDATE_PROFILE_DONE_ERROR } from "../profile";
import {
  handleAppSelectedSubtopic,
  handleAppSelectedSubtopicToSaveMsg,
  handleAppSelectedTopic,
  handleAppSelectedTopicToSaveMsg,
  handleLoading,
  handleScrollToBottom,
  handleThreadScrollToBottom,
} from "../AppState/action";
import {
  handleDecryptSingleMessageData,
  msgEncrypter,
} from "../../../utils/messageEncrypt";
import { ATTACHMENTS_CHANGED, SHOULD_CALL_PUBNUB_GET_TOKEN } from "../AppState/type";
import { AccountLevelArkchatPermission, GroupLevelArkchatPermission, MessageType } from "../../../utils/constant";
import { REACT_APP_UPLOAD_PATH } from "../auth/resetpassword";
import session from "../../../utils/helper";

/**
 * Creates headers for API requests with optional additional headers
 * @param {Object} additionalHeaders - Object containing additional header key-value pairs
 * @returns {Object} Headers object for axios requests
 *
 * Examples:
 * headerRequest() // Basic headers with token
 * headerRequest({"x-api-key": "your-api-key"}) // Single additional header
 * headerRequest({
 *   "x-api-key": "your-api-key",
 *   "x-custom-header": "custom-value",
 *   "Accept": "application/json"
 * }) // Multiple additional headers
 */
// x-arkchat-features: this app takes messages to everyone without their
// recipient lists (an entry per member: most of the message in a big group);
// it loads a message's recipients when they're opened (see RecipientList).
const FEATURES = "compact-recipients";
const headerRequest = (additionalHeaders = {}) => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getCookie("token")}`,
      "x-arkchat-features": FEATURES,
      ...additionalHeaders,
    },
  };
};

const attachmentheaderRequest = () => {
  return {
    headers: {
      // "Content-Type": "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getCookie("token")}`,
    },
  };
};

// Group and Dm List for sidebar Api's and functions

export const updateGroupArchiveKeyInDb =
  (pnId, isArchived) => async (dispatch) => {
    try {
      await updateArchiveKeyInGroupList(pnId, isArchived);
      const subscriber_id = getCookie("subsCriber_id") || false;
      let archiveGroupData;
      if (subscriber_id) {
        archiveGroupData = await getArchiveGroupsData(subscriber_id);
        dispatch({
          type: actionTypes.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS,
          payload: archiveGroupData,
        });
      }

      let allmemberswithgroupsData;
      if (subscriber_id) {
        allmemberswithgroupsData = await getGroupDMListData(subscriber_id);
        dispatch({
          type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
          payload: allmemberswithgroupsData,
        });
      }
    } catch (error) { }
  };

export const requestArchiveGroup = (group_pnId) => async (dispatch) => {
  try {
    let API_URL = `${process.env.REACT_APP_BASE_PATH}/group/archive/${group_pnId}`;
    // dispatch(requestShowLoader());
    const responseData = await axios.get(API_URL, headerRequest());
    dispatch(
      showToastMsg(
        responseData?.data?.message
          ? responseData?.data?.message
          : responseData?.message,
      ),
    );
    return responseData;
  } catch (err) {
    // dispatch(requestHiderLoader());
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

const updateAllmemberswithgroupsDb = async (endpoint, isArchivedList = 0) => {
  try {
    let API_URL = `${process.env.REACT_APP_BASE_PATH}/${endpoint}`;
    const token = getCookie("token");
    const subscriber_id = getCookie("subsCriber_id");
    const response = await axios.get(API_URL, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      // Dispatch the profile data
      await sotreGroupDMListData(
        subscriber_id,
        response.data.data,
        isArchivedList,
      );
      return response?.data?.data;
    }
  } catch (err) {
    // console.error("Background API call error:", err);
  }
};

export const requestGetArchiveGroupList =
  (forceFetch = false) =>
    async (dispatch) => {
      try {
        // dispatch(requestShowLoader());
        let API_URL = `${process.env.REACT_APP_BASE_PATH}/group/archive`;
        const subscriber_id = getCookie("subsCriber_id") || false;
        let archiveGroupData;
        if (subscriber_id) {
          archiveGroupData = await getArchiveGroupsData(subscriber_id);
        }
        if (archiveGroupData?.length > 0 && subscriber_id) {
          dispatch({
            type: actionTypes.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS,
            payload: archiveGroupData,
          });
          updateAllmemberswithgroupsDb("group/archive", 1).then((updatedData) => {
            if (updatedData) {
              dispatch({
                type: actionTypes.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS,
                payload: updatedData,
              });
            }
          });
        } else {
          const responseData = await axios.get(API_URL, headerRequest());
          await sotreGroupDMListData(subscriber_id, responseData.data.data, 1);
          dispatch({
            type: actionTypes.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS,
            payload: responseData?.data?.data,
          });
          return responseData;
        }
      } catch (err) {
        // dispatch(requestHiderLoader());
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      }
    };

export const requestDeleteGroup = (groupId) => async (dispatch) => {
  try {
    dispatch(requestShowLoader());
    const responseData = await axios.delete(
      `${process.env.REACT_APP_BASE_PATH}/group/${groupId}`,
      headerRequest(),
    );
    dispatch(
      showToastMsg(
        responseData?.data?.message
          ? responseData?.data?.message
          : responseData?.message,
      ),
    );
    return responseData;
  } catch (err) {
    dispatch(requestHiderLoader());
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const requestDeleteGroupFromDb = (groupId) => async (dispatch) => {
  try {
    await deleteGroupFrmGrpDb(groupId);
    const updateData = await getGroupDMListData();
    dispatch({
      type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
      payload: updateData,
    });
    return updateData;
  } catch (err) {
    dispatch(requestHiderLoader());
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const requestUpdateGroupDb = (data) => async (dispatch) => {
  try {
    const { timetoken, ...grpData } = data;
    await updateGroupDMListData(data?.pnId, grpData);
    // The group may be archived, or listed in the invite list.
    await dispatch(refreshGroupLists());
  } catch (error) { }
};

// Re-read the main and archive group lists from the local DB (the Track Work
// and Performance lists are built from these), and the invite list if it has
// been loaded.
const refreshGroupLists = () => async (dispatch, getState) => {
  dispatch({
    type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
    payload: await getGroupDMListData(),
  });
  dispatch({
    type: actionTypes.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS,
    payload: await getArchiveGroupsData(),
  });
  if (getState()?.arkchatgroup?.allGroupInvite?.data) {
    dispatch(getAllGroupInvites());
  }
};

// The user left or was removed: drop the group from every list right away.
// A list re-fetch alone isn't enough: it only adds/updates local rows, so the
// group came back the next time a list was re-read from the local DB.
export const removeGroupFromLists = ({ pnId, groupId }) => async (dispatch) => {
  await deleteGroupLocally(pnId, groupId);
  await dispatch(refreshGroupLists());
};

// A group was deleted for my team: drop it from every list. Resolves to
// whether it was still listed, so only the first of the signal and the
// delete request moves the open chat off it.
export const dropDeletedGroup = ({ pnId, groupId }) => async (dispatch, getState) => {
  const { groupList, archiveGroupList } = getState()?.arkchatgroup || {};
  const listed = [...(groupList || []), ...(archiveGroupList || [])].some(
    (g) => String(g?.id) === String(groupId) || (pnId && g?.pnId === pnId)
  );
  await dispatch(removeGroupFromLists({ pnId, groupId }));
  return listed;
};

// The account owner deletes a group for the whole team. External members
// keep it, shown as removed.
export const requestDeleteGroupForTeam = (groupId) => async (dispatch) => {
  try {
    const responseData = await axios.delete(
      `${process.env.REACT_APP_BASE_PATH}/group/team/${groupId}`,
      headerRequest(),
    );
    dispatch(showToastMsg(responseData?.data?.message));
    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const requestEditGroupName = (groupId, reqbody) => async (dispatch) => {
  try {
    dispatch(requestShowLoader());
    const responsedata = await axios.put(
      `${process.env.REACT_APP_BASE_PATH}/group/edit/${groupId}`,
      reqbody,
      headerRequest(),
    );
    dispatch(
      showToastMsg(responsedata?.data?.message || responsedata?.message),
    );
    return responsedata;
  } catch (err) {
    dispatch(requestHiderLoader());
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const requestCreatFirstGroup = (formData) => {
  let API_URL = `${process.env.REACT_APP_BASE_PATH}/group/gettingstarted`;
  const token = getCookie("token");
  return (dispatch) => {
    return axios
      .post(API_URL, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res?.status === 200) {
          dispatch({
            type: actionTypes.REQUEST_CREATE_FIRST_GROUP,
            payload: res?.data?.data,
          });
          return res?.data;
        } else {
          dispatch({
            type: actionTypes.CREATE_FIRST_GROUP_ERROR,
            payload: res?.data,
          });
          return res?.data;
        }
      })
      .catch((err) => {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      });
  };
};

export const requestallmemberswithgroups = ({
  forceFetch = false,
  isSignalData = false,
  createdData,
}) => {
  let API_URL = `${process.env.REACT_APP_BASE_PATH}/group/all-members-with-groups`;
  const token = getCookie("token");
  return async (dispatch) => {
    try {
      const subscriber_id = getCookie("subsCriber_id") || false;

      let allmemberswithgroupsData;
      if (subscriber_id) {
        allmemberswithgroupsData = await getGroupDMListData(subscriber_id);
      }
      const paylodaData = {
        data: allmemberswithgroupsData,
      };
      let updatedGroupData;
      if (allmemberswithgroupsData?.length > 0 && !forceFetch && subscriber_id) {
        if (isSignalData) {
          const alreadyExists = paylodaData?.data?.some((g) => g.id === createdData?.id);
          updatedGroupData = alreadyExists ? paylodaData?.data : [createdData, ...paylodaData?.data];
          dispatch({
            type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
            payload: updatedGroupData,
          });
          dispatch({
            type: SHOULD_CALL_PUBNUB_GET_TOKEN,
            payload: true,
          });
          await sotreGroupDMListData(subscriber_id, updatedGroupData, 0);
        }
        // If data is present, dispatch it
        else {
          dispatch({
            type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
            payload: paylodaData?.data,
          });
          updateAllmemberswithgroupsDb("group/all-members-with-groups", 0).then(
            (updatedData) => {
              if (updatedData) {
                dispatch({
                  type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
                  payload: updatedData,
                });
                dispatch({
                  type: SHOULD_CALL_PUBNUB_GET_TOKEN,
                  payload: true,
                });
              }
            },
          );
          return paylodaData?.data;
        }

        return updatedGroupData;
      } else {
        // If data is not present, make an API call
        const response = await axios.get(API_URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          // Dispatch the profile data
          await sotreGroupDMListData(subscriber_id, response.data.data, 0);
          dispatch({
            type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
            payload: response?.data?.data,
          });
          dispatch({
            type: SHOULD_CALL_PUBNUB_GET_TOKEN,
            payload: true,
          });
          return response?.data?.data;
        } else {
          dispatch({
            type: actionTypes.REQUEST_ALL_MEMBERS_WITH_GROUP_ERROR,
            payload: response,
          });
        }
      }
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

// A file was renamed: it now has a new name and storage location. Update the
// message wherever it's shown (local DB, chat, open thread) and let an open
// Files section re-read its list.
export const handleAttachmentsRenamed = (content) => async (dispatch, getState) => {
  const { id, temp_timetoken, attachments, pnid } = content || {};
  if (!id || !Array.isArray(attachments)) return;
  await replaceMessageAttachments(id, attachments);
  const message = getState()?.arkchatgroup?.messageList?.find(
    (m) => m?.id === id || (temp_timetoken && m?.temp_timetoken === temp_timetoken),
  );
  if (message) {
    dispatch({
      type: actionTypes.UPDATE_EXISTING_MESSAGE_LIST,
      payload: { timetoken: message.timetoken, attachments },
    });
  }
  if (temp_timetoken) {
    dispatch({
      type: actionTypes.UPDATE_EXISTING_THREAD_MESSAGE,
      payload: { temp_timetoken, attachments },
    });
  }
  dispatch({ type: ATTACHMENTS_CHANGED, payload: { pnId: pnid } });
};

export const handleUpdateGroupSorting =
  (pnId, updatedTimeToken, actiVeGroupPnId, lastMessage = null) => async (dispatch, getState) => {
    const isUpdateCount = actiVeGroupPnId === pnId;
    await updateGroupDMListDataTimetoken(pnId, updatedTimeToken, isUpdateCount, lastMessage);
    // The list in the store with this chat updated and moved to its place
    // (newest first), as reading it back from the database would give:
    // reading back every chat (a contact per member in a big account) and
    // sorting them on each message kept the browser busy.
    const list = getState()?.arkchatgroup?.groupList;
    const index = Array.isArray(list) ? list.findIndex((group) => group?.pnId === pnId) : -1;
    if (index !== -1) {
      const current = list[index];
      const updated = {
        ...current,
        timetoken: updatedTimeToken,
        ...(!isUpdateCount && { messageCount: +current.messageCount + 1 }),
        ...(lastMessage && { lastMessage }),
      };
      const rest = list.filter((_, i) => i !== index);
      let at = rest.findIndex((group) => !(Number(group?.timetoken) > Number(updatedTimeToken)));
      if (at === -1) at = rest.length;
      dispatch({
        type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
        payload: [...rest.slice(0, at), updated, ...rest.slice(at)],
      });
    } else {
      const updateData = await getGroupDMListData();
      dispatch({
        type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
        payload: updateData,
      });
    }
    // An archived chat's preview and unread count live in the archive list.
    const archived = await getArchiveGroupsData();
    if (archived.some((group) => group?.pnId === pnId)) {
      dispatch({
        type: actionTypes.RECEIVED_ALL_ARCHIVE_GROUP_SUCCESS,
        payload: archived,
      });
    }
  };

export const requestCreatArkchatGroup = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/group/create`,
      reqBody,
      headerRequest(),
    );
    const { data } = responseData;
    // if(data?.code == 200) {
    //   await dispatch(requestallmemberswithgroups());
    // }
    return data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const getAllGroupInvites = () => async (dispatch) => {
  try {
    // Start loading
    dispatch({ type: actionTypes.REQUEST_ALL_GROUP_INVITE });

    // Actual API call (GET)
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/group/all-group-for-invite`,
      headerRequest(),
    );

    const { data } = response;

    dispatch({
      type: actionTypes.RECEIVED_ALL_GROUP_INVITE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (err) {
    console.error("❌ Failed to fetch group invites:", err);

    // Dispatch failure
    dispatch({
      type: actionTypes.FAILED_ALL_GROUP_INVITE,
      payload: err?.response,
    });
  }
};

export const getAllGroupAnalytics = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.REQUEST_ALL_GROUP_ANALYTICS });
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/group/all-group-for-analytics`,
      headerRequest(),
    );
    const { data } = response;
    dispatch({
      type: actionTypes.REQUEST_ALL_GROUP_ANALYTICS_SUCCESS,
      payload: data,
    });
    return data;
  } catch (err) {
    console.error("Failed to fetch group invites:", err);
    dispatch({
      type: actionTypes.FAILED_ALL_GROUP_ANALYTICS,
      payload: err?.response,
    });
  }
};

export const updateGroupOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.REQUEST_ALL_GROUP_ANALYTICS });
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/group/order`,
      { order: orderData },
      headerRequest(),
    );
    const { data } = response;
    dispatch({
      type: actionTypes.REQUEST_ALL_GROUP_ANALYTICS_SUCCESS,
      payload: data,
    });
    return data;
  } catch (err) {
    console.error("Failed to update group order:", err);
    dispatch({
      type: actionTypes.FAILED_ALL_GROUP_ANALYTICS,
      payload: err?.response,
    });
  }
};

export const requestCreateGroupWithmember = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/group/`,
      reqBody,
      headerRequest(),
    );
    const { data } = responseData;
    if (data?.code === 200) {
      dispatch(showToastMsg(data?.message || responseData?.message));
      dispatch(requestallmemberswithgroups({ isSignalData: true, createdData: data?.data }));
    }
    return data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

// export const requestSelectedSpecificperson = (userId) => async (dispatch) => {
//   try {
//     const responsedata = await axios.post(
//       `${process.env.REACT_APP_BASE_PATH}/chats/user/${userId}`,
//       { groupId: 0, topicId: 0 },
//       headerRequest()
//     );
//     const { data } = responsedata;
//     if (responsedata?.status) {
//       dispatch({
//         type: actionTypes.RECEIVED_GROUP_MESSAGE_LIST,
//         payload: data?.data,
//       });
//     }
//   } catch (err) {
//     dispatch({ type: REQUEST_FAILED, payload: err?.response });
//   }
// };

// Group people split as the store holds them: internal (owner and users)
// and external members.
const splitGroupPeople = (people) => {
  const external = [];
  const internal = [];
  people.forEach((item) => {
    if (item?.inviteType === 0 || item?.inviteType === 1) {
      internal.push(item);
    }

    if (item?.inviteType === 2) {
      external.push(item);
    }
  });
  return { internal, external };
};

// A group's people (GET /group/members, a page at a time: the first, then
// the rest together), as { accountId (the group's account), members,
// accounts (by id) }, or null when it can't be loaded. scope "members": its
// members and its account's admins; "account": everyone in its account.
// Loads of a group's list at the same moment (opening a group asks for its
// people and its recipients at once) share one.
const MEMBERS_PAGE_SIZE = 1000;
const groupMembersInFlight = new Map();
const loadGroupMembers = (groupId, scope = "members") => {
  const key = `${groupId}|${scope}`;
  if (groupMembersInFlight.has(key)) return groupMembersInFlight.get(key);
  const getPage = async (page) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/group/members/${groupId}`,
      { ...headerRequest(), params: { scope, page, page_size: MEMBERS_PAGE_SIZE } },
    );
    return data?.status ? data : null;
  };
  const load = (async () => {
    const first = await getPage(1);
    if (!first) return null;
    const pages = Math.ceil((first.count || 0) / MEMBERS_PAGE_SIZE);
    const rest = await Promise.all(
      Array.from({ length: Math.max(0, pages - 1) }, (_, i) => getPage(i + 2)),
    );
    if (rest.some((page) => !page)) return null;
    const all = [first, ...rest];
    return {
      accountId: first.data?.accountId,
      members: all.flatMap((page) => page.data?.members || []),
      accounts: new Map(all.flatMap((page) => page.data?.accounts || []).map((a) => [a.id, a])),
    };
  })().finally(() => groupMembersInFlight.delete(key));
  groupMembersInFlight.set(key, load);
  return load;
};

// A /group/members entry as the group's people have it (as in its account's
// team list: inviteType and permission are the group account's, an external
// member being its contact there), with what the app reads of it. Profile
// fields (bio, cover, website, LinkedIn) load with the profile card.
const toGroupPeopleEntry = (member, accounts, groupAccountId) => {
  const account = accounts.get(member.accountId) || {};
  return {
    userId: member.userId,
    subscriberId: groupAccountId,
    targetSubscriberId: member.external ? member.accountId : member.targetSubscriberId,
    permission: member.external ? AccountLevelArkchatPermission.USER : member.accountPermission,
    inviteType: member.external ? 2 : member.isAccountOwner ? 0 : 1,
    membership: member.membership,
    languageCode: member.languageCode,
    permissionType: member.permissionType,
    userInfo: {
      id: member.userId,
      firstName: member.firstName,
      lastName: member.lastName,
      profileImgUrl: member.profileImgUrl,
      membership: member.membership,
    },
    userData: {
      id: member.accountId,
      subscriberFirmName: account.subscriberFirmName,
      subscriberPriority: account.subscriberPriority,
      subscriberAccountType: account.subscriberAccountType,
      subscriberAccountIndustry: account.subscriberAccountIndustry,
      city: account.city,
      country: account.country,
    },
  };
};

// A /group/members entry as the group's recipients have it: inviteType is
// External when they're from another account than the viewer's.
const toGroupRecipientEntry = (member, accounts, myAccountId) => {
  const account = accounts.get(member.accountId) || {};
  return {
    userId: member.userId,
    targetSubscriberId: member.accountId,
    firstName: member.firstName,
    lastName: member.lastName,
    profileImgUrl: member.profileImgUrl,
    languageCode: member.languageCode,
    inviteType: member.accountId === myAccountId ? (member.isAccountOwner ? 0 : 1) : 2,
    subscriberFirmName: account.subscriberFirmName,
    subscriberPriority: account.subscriberPriority,
    groupPermission: member.permissionType,
    accountPermission: member.accountPermission,
    membership: member.membership,
  };
};

// The group's recipients (its members, not its account's other admins), or
// null when they can't be loaded.
const loadGroupRecipients = async (groupId, getState) => {
  const list = await loadGroupMembers(groupId);
  if (!list) return null;
  // Who counts as internal depends on the account I'm in this group from, which
  // needn't be the active one (the chat list has every workspace's groups).
  const profile = getState()?.profile?.profileData?.data;
  const myAccountId =
    list.members.find((member) => member.userId === profile?.id)?.accountId ?? profile?.activeSubscriber?.id;
  return list.members
    .filter((member) => member.permissionType !== GroupLevelArkchatPermission.REMOVE)
    .map((member) => toGroupRecipientEntry(member, list.accounts, myAccountId));
};

// The store's group people: the group's members and the account's admins
// (scope "members"), not everyone in the account; Add Member loads those
// itself (requestAccountPeopleForGroup).
export const requestgroupMemberDetails =
  (reqBody, abortSignal) => async (dispatch) => {
    try {
      const list = await loadGroupMembers(reqBody?.group_id);
      // A request for a group that's no longer open: drop it.
      if (!list || abortSignal?.aborted) return;
      const { internal, external } = splitGroupPeople(
        list.members.map((member) => toGroupPeopleEntry(member, list.accounts, list.accountId)),
      );

      dispatch({
        type: actionTypes.RECEVED_GROUDP_MEMBER_SUCCESS,
        payload: {
          // Which group these members are for (the store holds one group's).
          groupId: reqBody?.group_id,
          internalMember: internal,
          externalMember: external,
        },
      });

      return { internalMember: internal, externalMember: external };
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

// Everyone in the group's account, each with their permission in the group
// (Remove when they're not in it), for Add Member: { internalMember,
// externalMember }, not kept in the store.
export const requestAccountPeopleForGroup = (reqBody) => async () => {
  try {
    const list = await loadGroupMembers(reqBody?.group_id, "account");
    if (list) {
      const { internal, external } = splitGroupPeople(
        list.members.map((member) => toGroupPeopleEntry(member, list.accounts, list.accountId)),
      );
      return { internalMember: internal, externalMember: external };
    }
  } catch (err) {
    // Add Member shows the group's people meanwhile
  }
  return null;
};

export const getGroupRecipient = (group_Id, abortSignal) => async (dispatch, getState) => {
  try {
    const recipients = await loadGroupRecipients(group_Id, getState);
    return abortSignal?.aborted ? undefined : recipients || undefined;
  } catch (err) { }
};

export const requestGetGroupRecipient =
  (group_Id, abortSignal) => async (dispatch, getState) => {
    try {
      const recipients = await loadGroupRecipients(group_Id, getState);
      if (!recipients) return { status: false };
      if (!abortSignal?.aborted) {
        dispatch({
          type: actionTypes.GROUDP_RECIPIENT_DETAILS,
          payload: recipients,
          groupId: group_Id,
        });
      }
      return { status: true, data: recipients };
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const requestUpdateFromSignalGroupRecipient =
  (Updated_data) => async (dispatch) => {
    try {
      if (Updated_data?.length > 0) {
        dispatch({
          type: actionTypes.GROUDP_RECIPIENT_DETAILS,
          payload: Updated_data,
        });
      }
      return Updated_data;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const requestAddmemberInGroup = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/group/people/add`,
      reqBody,
      headerRequest(),
    );

    const { data } = responseData;
    dispatch(showToastMsg(data?.message));
    return data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleExitFromGroup = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/group/people/exit`,
      reqBody,
      headerRequest(),
    );

    const { data } = responseData;

    return data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleDeleteGroupTopic = (topicId) => async (dispatch) => {
  try {
    const responseData = await axios.delete(
      `${process.env.REACT_APP_BASE_PATH}/group/topic/${topicId}`,
      headerRequest(),
    );

    return responseData;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleDeactivatePrivateChat =
  (reqBody, groupId) => async (dispatch) => {
    try {
      const responseData = await axios.post(
        `${process.env.REACT_APP_BASE_PATH}/group/managesettings/${groupId}`,
        reqBody,
        headerRequest(),
      );

      dispatch(showToastMsg(responseData?.data?.message));

      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

// export const getAccountMeberPermissionByGroup =
//   (reqObj) => async (dispatch) => {
//     try {
//       const responsedata = axios.get(
//         `${process.env.REACT_APP_BASE_PATH}/group/user/permission?group_id=${reqObj?.groupId}&user_id=${reqObj?.userId}`,
//         headerRequest()
//       );
//       const { data } = responsedata;
//       return data;
//     } catch (err) {
//       dispatch({ type: REQUEST_FAILED, payload: err?.response });
//     }
//   };

export const profileLanguageUpdate = (formData, groupId) => {
  let API_URL = `${process.env.REACT_APP_BASE_PATH}/group/chat/${groupId}`;
  const subscriber_id = getCookie("subsCriber_id") || false;
  const token = getCookie("token");
  return async (dispatch) => {
    return axios
      .put(API_URL, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (res) => {
        if (res.status === 200) {
          if (subscriber_id) {
            dispatch({
              type: UPDATE_PROFILE_DONE,
              payload: res?.data?.data,
            });
            await storeProfileData(subscriber_id, res?.data?.data);
          }
          return res?.data;
        } else {
          dispatch({
            type: UPDATE_PROFILE_DONE_ERROR,
            payload: res?.data?.data,
          });
          return res?.data;
        }
      })
      .catch((err) => {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
        //
      });
  };
};

// The active account's team list (GET /onboarding/subscriber/team, a page at
// a time: the first, then the rest together), in the form the app's lists
// have it (as GET /user/list did), with what they read of each person;
// profile fields (bio, cover, LinkedIn) load with the profile card. Null when
// it can't be loaded. Loads at the same moment share one.
const TEAM_PAGE_SIZE = 1000;
let accountTeamInFlight = null;
const toAccountPeopleEntry = (member, accounts) => {
  const account = accounts.get(member.accountId) || {};
  return {
    userId: member.userId,
    subscriberId: member.subscriberId,
    targetSubscriberId: member.targetSubscriberId,
    permission: member.permission,
    inviteType: member.inviteType,
    membership: member.membership,
    membershipType: member.membershipType,
    languageCode: member.languageCode,
    userInfo: {
      id: member.userId,
      firstName: member.firstName,
      lastName: member.lastName,
      profileImgUrl: member.profileImgUrl,
      membership: member.membership,
      activeSubscriber: { id: member.activeSubscriberId },
    },
    userData: {
      id: member.accountId,
      subscriberFirmName: account.subscriberFirmName,
      subscriberPriority: account.subscriberPriority,
      subscriberAccountType: account.subscriberAccountType,
      subscriberAccountIndustry: account.subscriberAccountIndustry,
      city: account.city,
      country: account.country,
      website: account.website,
      profileImgUrl: account.profileImgUrl,
    },
  };
};
const fetchTeam = async (accountId) => {
  const getPage = async (page) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/onboarding/subscriber/team`,
      {
        ...headerRequest(),
        params: { page, page_size: TEAM_PAGE_SIZE, ...(accountId ? { target_subscriber_id: accountId } : {}) },
      },
    );
    return data?.status ? data : null;
  };
  const first = await getPage(1);
  if (!first) return null;
  const pages = Math.ceil((first.count || 0) / TEAM_PAGE_SIZE);
  const rest = await Promise.all(
    Array.from({ length: Math.max(0, pages - 1) }, (_, i) => getPage(i + 2)),
  );
  if (rest.some((page) => !page)) return null;
  const all = [first, ...rest];
  const accounts = new Map(all.flatMap((page) => page.data?.accounts || []).map((a) => [a.id, a]));
  return all.flatMap((page) => page.data?.members || []).map((member) => toAccountPeopleEntry(member, accounts));
};

const loadAccountTeam = () => {
  if (accountTeamInFlight) return accountTeamInFlight;
  accountTeamInFlight = fetchTeam().finally(() => {
    accountTeamInFlight = null;
  });
  return accountTeamInFlight;
};

// Contacts while "All" is shown: every workspace's team, each person once. A
// team that can't be loaded is left out rather than failing the rest.
export const requestAllWorkspacesPeople = () => async (dispatch, getState) => {
  try {
    const profile = getState()?.profile?.profileData?.data;
    const workspaces = profile?.subscribedTo || [];
    const teams = await Promise.all(
      workspaces.map(async (workspace) => ({
        id: workspace?.id,
        name: workspace?.subscriberFirmName,
        members: (await fetchTeam(workspace?.id).catch(() => null)) || [],
      })),
    );
    dispatch({
      type: actionTypes.RECEIVED_ALL_WORKSPACE_PEOPLE,
      payload: mergeWorkspaceTeams(teams, profile?.id),
    });
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

const updateAllAcountLevelMemberDb = async () => {
  try {
    const subscriber_id = getCookie("subsCriber_id");
    const accounyLeveluser = await loadAccountTeam();

    if (accounyLeveluser) {
      const external = [];
      const internal = [];
      // eslint-disable-next-line array-callback-return
      accounyLeveluser.map((item) => {
        if (item?.inviteType === 0 || item?.inviteType === 1) {
          internal.push(item);
        }

        if (item?.inviteType === 2) {
          external.push(item);
        }
      });
      // Dispatch the profile data
      await sotreAllAcountLevelMember(subscriber_id, {
        internalMember: internal,
        externalMember: external,
      });
      return { internal, external };
    }
  } catch (err) {
    // console.error("Background API call error:", err);
  }
};

export const requestGetAllAcountLevelMember =
  (forceFetch = false) =>
    async (dispatch) => {
      try {
        const subscriber_id = getCookie("subsCriber_id");
        const allAcountLevelMemberData =
          await getAllAcountLevelMember(subscriber_id);
        if (allAcountLevelMemberData?.length > 0 && !forceFetch) {
          dispatch({
            type: actionTypes.RECEIVED_ONBOARDING_ACCOUNT_MEMBER,
            payload: allAcountLevelMemberData[0]?.data,
          });
          updateAllAcountLevelMemberDb().then((updatedData) => {
            dispatch({
              type: actionTypes.RECEIVED_ONBOARDING_ACCOUNT_MEMBER,
              payload: {
                internalMember: updatedData?.internal,
                externalMember: updatedData?.external,
              },
            });
          });
        } else {
          const accounyLeveluser = await loadAccountTeam();
          if (!accounyLeveluser) return;
          const external = [];
          const internal = [];
          // eslint-disable-next-line array-callback-return
          accounyLeveluser.map((item) => {
            if (item?.inviteType === 0 || item?.inviteType === 1) {
              internal.push(item);
            }

            if (item?.inviteType === 2) {
              external.push(item);
            }
          });
          dispatch({
            type: actionTypes.RECEIVED_ONBOARDING_ACCOUNT_MEMBER,
            payload: {
              internalMember: internal,
              externalMember: external,
            },
          });
          await sotreAllAcountLevelMember(subscriber_id, {
            internalMember: internal,
            externalMember: external,
          });
        }
      } catch (err) {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      }
    };

// export const uploadAttachment = (files, pnId) => async () => {
//   try {
//     const responseData = await axios.post(
//       `${process.env.REACT_APP_BASE_PATH}/chats/attachment/${pnId}`,
//       files,
//       attachmentheaderRequest()
//     );
//     if (responseData?.data?.status) {
//       return responseData?.data?.data;
//     }
//   } catch (error) {}
// };

export const uploadAttachment =
  (files, pnId, config = {}) =>
    async (dispatch) => {
      try {
        const headersConfig = attachmentheaderRequest();

        const responseData = await axios.post(
          `${process.env.REACT_APP_BASE_PATH}/chats/attachment/${pnId}`,
          files,
          {
            ...headersConfig,
            ...config,
          },
        );

        if (responseData?.data?.status) {
          return responseData?.data?.data;
        }
      } catch (error) {
        // console.error("Error uploading file:", error);
        throw error;
      }
    };

// Message related fun()

const safeDecryptJson = (text, key, iv) => {
  if (!text) return {};
  try {
    const decrypted = msgEncrypter.decrypt(text, key, iv);
    return decrypted ? JSON.parse(decrypted) : {};
  } catch (e) {
    return {};
  }
};

const decryptApprovalTabData = (item) => {
  if (!item) return item;

  const decrypted = { ...item };

  // decrypt message
  if (decrypted.message) {
    decrypted.message = msgEncrypter.decrypt(
      decrypted.message,
      process.env.REACT_APP_ENC_KEY,
      decrypted.kuncika,
    );
  }

  // decrypt translations
  if (decrypted.translations) {
    decrypted.translations = safeDecryptJson(
      decrypted.translations,
      process.env.REACT_APP_ENC_KEY,
      decrypted.kuncika,
    );
  }

  // recursively decrypt chain
  if (decrypted.chain) {
    decrypted.chain = decryptApprovalTabData(decrypted.chain);
  }

  return decrypted;
};

export const handleDecryptMessageData = (
  messageDatas,
  isTaskTab = false,
  isApprovalkTab = false,
) => {
  try {
    // isTndA = for task and approval tab data
    let decryptedMsgData = [];
    if (isTaskTab) {
      decryptedMsgData = messageDatas?.map((item, i) => {
        return {
          ...item,
          message: msgEncrypter.decrypt(
            item?.message,
            process.env.REACT_APP_ENC_KEY,
            item?.kuncika,
          ),
          translations: safeDecryptJson(
            item?.translations,
            process.env.REACT_APP_ENC_KEY,
            item?.kuncika,
          ),
          balah: item?.balah?.map((balahItem) => {
            return {
              ...balahItem,
              message: msgEncrypter.decrypt(
                balahItem?.message,
                process.env.REACT_APP_ENC_KEY,
                balahItem?.kuncika,
              ),
              translations: safeDecryptJson(
                balahItem?.translations,
                process.env.REACT_APP_ENC_KEY,
                balahItem?.kuncika,
              ),
            };
          }),
        };
      });

      return decryptedMsgData;
    }
    if (isApprovalkTab) {
      decryptedMsgData = messageDatas?.map(decryptApprovalTabData);

      return decryptedMsgData;
    }
    decryptedMsgData = messageDatas?.map((item, i) => {
      if (
        item?.thread_original_message &&
        (item?.thread_original_message?.id ||
          item?.thread_original_message?.message)
      ) {
        return {
          ...item,
          message: msgEncrypter.decrypt(
            item?.message,
            process.env.REACT_APP_ENC_KEY,
            item?.kuncika,
          ),
          translations: safeDecryptJson(
            item?.translations,
            process.env.REACT_APP_ENC_KEY,
            item?.kuncika,
          ),
          thread_original_message: {
            ...item?.thread_original_message,
            message: msgEncrypter.decrypt(
              item?.thread_original_message?.message,
              process.env.REACT_APP_ENC_KEY,
              item?.kuncika,
            ),
            translations: safeDecryptJson(
              item?.thread_original_message?.translations,
              process.env.REACT_APP_ENC_KEY,
              item?.kuncika,
            ),
          },
        };
      } else {
        return {
          ...item,
          message: msgEncrypter.decrypt(
            item?.message,
            process.env.REACT_APP_ENC_KEY,
            item?.kuncika,
          ),
          translations: safeDecryptJson(
            item?.translations,
            process.env.REACT_APP_ENC_KEY,
            item?.kuncika,
          ),
        };
      }
    });
    return decryptedMsgData;
  } catch (error) { }
};

const getMessagesFromAPI = async ({
  pnId,
  payload = {},
  page = 1,
  page_size = 50,
  selectedGroup = true,
  lastTimeToken = null,
  before_timetoken = null,
  abortSignal,
}) => {
  if (!selectedGroup) {
    payload = {
      type: 3,
    };
  }
  if (lastTimeToken) {
    payload = {
      ...payload,
      timetoken: lastTimeToken,
    };
  }
  if (before_timetoken) {
    payload = {
      ...payload,
      before_timetoken,
    };
  }
  try {
    let url = `${process.env.REACT_APP_BASE_PATH}/chats/messages/${pnId}?page=${page}&page_size=${page_size}`;

    // Prepare the options for the axios request
    const options = {
      ...headerRequest(),
      ...(abortSignal && { signal: abortSignal }), // Add signal to the options if present
    };

    const responseData = await axios.post(url, payload, options);
    if (responseData.status === 200) {
      const decryptedMessageData = handleDecryptMessageData(
        responseData?.data?.data?.messages,
      );
      return { ...responseData?.data?.data, messages: decryptedMessageData };
    }
  } catch (err) { }
};

export const handleGetUpdatedMsgData = () => async (dispatch) => {
  try {
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/chats/activity`,
      headerRequest(),
    );
    if (responseData?.data?.code === 200) {
      const { approval, task, delete_message } = responseData?.data?.data;
      let msgToUpdateToken = [];
      if (approval?.length > 0) {
        msgToUpdateToken = [...msgToUpdateToken, ...approval];
      }
      if (task?.length > 0) {
        msgToUpdateToken = [...msgToUpdateToken, ...task];
      }
      if (task?.length > 0 || approval?.length > 0) {
        dispatch(handleFetchConversation({ timetoken: msgToUpdateToken })).then(
          async (res) => {
            for (let i = 0; i < res?.length; i++) {
              if (res[i]?.message?.timetoken) {
                let decryptedData = handleDecryptSingleMessageData(
                  res[i]?.message,
                );
                await updateMessageToDb(
                  res[i]?.pnId,
                  res[i]?.message?.temp_timetoken,
                  decryptedData,
                );
              }
            }
          },
        );
      }
      if (delete_message?.length > 0) {
        for (let i = 0; i < delete_message?.length; i++) {
          await deleteMsgFromDb(delete_message[i]);
        }
      }
      const reqBody = {
        task: true,
        approval: true,
        delete_message: true,
      };
      dispatch(handleUpdatedMsgDataSyncedToServer(reqBody));
    }
    return;
  } catch (error) { }
};

export const handleUpdatedMsgDataSyncedToServer =
  (reqBoby) => async (dispatch) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_PATH}/chats/activity`,
        reqBoby,
        headerRequest(),
      );
      return;
    } catch (error) { }
  };

export const fetchOldMessageFromApi =
  (selectedGroup, payload = {}, silent = false, beforeTimetoken) =>
    async (dispatch) => {
      try {
        // POST /chats/messages/:pnId (fetchAllMessages) uses a before_timetoken
        // cursor for older-message pagination (see ConversationController.fetchAllMessages).
        // Cursor-based pagination stays correct even when new messages keep
        // arriving concurrently — skip/page-based pagination would drift and
        // permanently skip whole windows of older history in that case.
        const res = await getMessagesFromAPI({
          pnId: selectedGroup?.pnId,
          payload: payload,
          before_timetoken: beforeTimetoken,
          page_size: 50,
          selectedGroup: selectedGroup?.isGroup,
        });
        const newMessages = (res?.messages || [])
          .slice()
          .sort((a, b) => a.timetoken - b.timetoken);
        if (newMessages.length > 0) {
          if (!silent) {
            dispatch({
              type: actionTypes.RECEIVED_OLD_MESSAGE_LIST,
              payload: newMessages,
            });
          }
          // A topic's or subtopic's messages aren't stored (see handleFetchMessages).
          if (!payload?.topicId && !payload?.subtopicId) {
            await storeMessageToDb(newMessages);
          }
        }
        return newMessages;
      } catch (e) {
        // Return null (not []) so callers can distinguish a transient error
        // from a genuine "no more messages" response and allow a retry.
        return null;
      }
    };

export const handleInternalPublisFun =
  (pnId, topic_id, callback, subtopicId = "") => async (dispatch) => {
    let messageData = await getMessageFromDb(pnId, topic_id);
    if (subtopicId) {
      messageData = messageData.filter((m) => m.subtopic_id === subtopicId);
    }
    dispatch({
      type: actionTypes.RECEIVED_GROUP_MESSAGE_LIST,
      payload: messageData,
    });
    if (callback) {
      callback();
    }
  };

export const handleSaveTempMsgData = (messageData, pnId) => async (dispatch) => {
  const decryptedMsg = handleDecryptSingleMessageData(messageData, true);
  await storeTempMessageToDb(decryptedMsg);
  const tempMsgData = await getTempStoreMessageData(pnId);
  dispatch({
    type: actionTypes.RECEIVED_TEMP_MESSAGE_LIST,
    payload: tempMsgData,
  });
};

export const handleGetTempMsgData = (pnId) => async (dispatch) => {
  const tempMsgData = await getTempStoreMessageData(pnId);
  dispatch({
    type: actionTypes.RECEIVED_TEMP_MESSAGE_LIST,
    payload: tempMsgData,
  });
};

export const handleDeleteTempMsgData =
  (temp_timetoken, pnId) => async (dispatch) => {
    await deleteTempMessageData(temp_timetoken);
    const tempMsgData = await getTempStoreMessageData(pnId);
    dispatch({
      type: actionTypes.RECEIVED_TEMP_MESSAGE_LIST,
      payload: tempMsgData,
    });
  };

export const handleUpdateExistingMessage =
  (
    pnId,
    data,
    shouldUpdateMessageList = false,
    messageCountToget,
    activeTopic,
  ) =>
    async (dispatch) => {
      const isThreadScreen = session.get("isThreadScreen");
      for (let i = 0; i < data?.length; i++) {
        let decryptedData = handleDecryptSingleMessageData(data[i]?.message);
        if (data[i]?.message?.temp_timetoken) {
          if (isThreadScreen) {
            // Only what these updates change (read status, topic): the open
            // thread keeps the rest of what it loaded. (It got decryptedData[0]
            // of a single message, i.e. nothing, so it never updated.)
            const patch = { temp_timetoken: decryptedData.temp_timetoken };
            ["read_by", "topic_id", "subtopic_id"].forEach((key) => {
              if (decryptedData[key] !== undefined) patch[key] = decryptedData[key];
            });
            dispatch({
              type: actionTypes.UPDATE_EXISTING_THREAD_MESSAGE,
              payload: patch,
            });
          }
          await updateMessageToDb(
            pnId,
            data[i]?.message?.temp_timetoken,
            decryptedData,
          );
        } else if (decryptedData?.timetoken) {
          await storeMessageToDb([decryptedData]);
        }
      }

      if (shouldUpdateMessageList) {
        let msgLimit =
          messageCountToget?.length <= 5 ? 10 : messageCountToget?.length;
        const messageData = await getMessageFromDb(
          pnId,
          activeTopic?.id,
          0,
          msgLimit,
        );
        // Use MERGE_MESSAGE_LIST instead of RECEIVED_GROUP_MESSAGE_LIST so that
        // older messages already loaded via scroll-up are not discarded. This
        // action only updates properties (is_read, topic_id, etc.) of messages
        // already visible; it does not replace the entire list.
        dispatch({
          type: actionTypes.MERGE_MESSAGE_LIST,
          payload: { messages: messageData, activeTopic },
        });
      }
    };

// A read receipt that names its reader: add them to those messages' read_by
// (local store and on screen) instead of re-fetching the messages.
export const handleApplyReadReceipt = (temp_timetokens, reader) => async (dispatch) => {
  await addReaderToMessages(temp_timetokens, reader);
  dispatch({ type: actionTypes.APPLY_READ_RECEIPT, payload: { temp_timetokens, reader } });
};

// A topic or subtopic was deleted (topic-deleted / subtopic-deleted signal).
// If it's the one open in the chat, go back to the group's messages (or the
// topic's), as closing it from the header does; if it was picked for new
// messages, unpick it. Reads the selection from the store, not a closure.
export const handleTopicOrSubtopicDeleted =
  ({ groupId, topicId, subtopicId }) => (dispatch, getState) => {
    const {
      selectedGroupData: group,
      selectedTopicData: topic,
      selectedSubtopicData: subtopic,
      selectedTopicToSaveMsg: topicToSave,
      selectedSubtopicToSaveMsg: subtopicToSave,
    } = getState()?.appStateData || {};
    if (!group?.id || group.id !== groupId) return;

    if (subtopicId) {
      if (subtopicToSave?.id === subtopicId) dispatch(handleAppSelectedSubtopicToSaveMsg(null));
      if (subtopic?.id === subtopicId) {
        dispatch(handleAppSelectedSubtopic(null));
        dispatch(handleFetchMessages(group.pnId, topic?.id || null, { topicId: topic?.id }));
      }
      return;
    }
    if (!topicId) return;
    if (topicToSave?.id === topicId) {
      dispatch(handleAppSelectedTopicToSaveMsg(null));
      dispatch(handleAppSelectedSubtopicToSaveMsg(null));
    }
    if (topic?.id === topicId) {
      dispatch(handleAppSelectedTopic(null));
      dispatch(handleAppSelectedSubtopic(null));
      dispatch(handleFetchMessages(group.pnId, null));
    }
  };

// Messages moved to another topic/subtopic (from POST /chats/messages): the
// open chat shows, hides or adds them for the topic/subtopic it's showing.
export const handleApplyTopicMove =
  (data, activeTopicId, activeSubtopicId) => (dispatch) => {
    const messages = (data || [])
      .filter((item) => item?.message?.temp_timetoken)
      .map((item) => handleDecryptSingleMessageData(item.message));
    dispatch({
      type: actionTypes.APPLY_TOPIC_MOVE,
      payload: { messages, activeTopicId, activeSubtopicId },
    });
  };

// A message's recipients, a page at a time, each with whether they've read it:
// { total, read_count, recipients: [{ id, name, pp, ..., read }] }.
export const fetchMessageRecipients = (pnId, tempTimetoken, page = 1, pageSize = 200) => async () => {
  try {
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/chats/message-recipients/${encodeURIComponent(pnId)}/${encodeURIComponent(tempTimetoken)}?page=${page}&page_size=${pageSize}`,
      headerRequest(),
    );
    if (responseData?.data?.status) {
      return responseData.data.data;
    }
  } catch (err) {
    // the list shows what it has
  }
  return null;
};

export const handleFetchConversation = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/chats/messages`,
      reqBody,
      headerRequest(),
    );
    if (responseData.status === 200) {
      return responseData?.data?.data;
    }
  } catch (err) {
    // console.error("Background API call error:", err);
  }
};

// A delivered message takes its pending copy's place in one update: the copy
// went first and the message came after it was saved locally, so the tile
// vanished for a moment (longer the busier the page). The pending copy is
// deleted locally first (so nothing reads it back), the message saved after.
export const handleInstantPubnubPublishMessage =
  (reqBody, activepnId, activeTopicId, temp_timetoken, activeSubtopicId = "") => async (dispatch) => {
    await deleteTempMessageData(temp_timetoken);
    if (reqBody[0]?.pnId === activepnId) {
      const msgSubtopicId = reqBody[0]?.subtopic_id || "";
      const msgTopicId = reqBody[0]?.topic_id || "";
      let shouldShow = false;
      if (activeSubtopicId) {
        shouldShow = msgSubtopicId === activeSubtopicId;
      } else if (activeTopicId) {
        shouldShow = msgTopicId === activeTopicId;
      } else {
        shouldShow = true;
      }
      if (shouldShow) {
        dispatch({
          type: actionTypes.RECEIVED_GROUP_INSTANT_MESSAGE_LIST,
          payload: reqBody[0],
        });
      }
    }
    dispatch({ type: actionTypes.REMOVE_TEMP_MESSAGE, payload: temp_timetoken });
    const shown = shownMessages.get(reqBody[0]?.pnId);
    if (shown && reqBody[0]?.timetoken > (shown[shown.length - 1]?.timetoken || 0)) {
      rememberShown(reqBody[0].pnId, [...shown, reqBody[0]].slice(-SYNC_PAGE_SIZE));
    }
    await storeMessageToDb(reqBody);
  };

export const handleMessageConfirmed =
  (confirmedMsg, activePnId, currentMessageList = []) => async (dispatch) => {
    const { temp_timetoken, pnId, timetoken, id: messageId, createdAt, thread_number } = confirmedMsg;
    if (!temp_timetoken || !pnId) return;

    const allTempMsgs = await getTempStoreMessageData(pnId);
    const tempMsg = allTempMsgs.find(m => m.temp_timetoken === temp_timetoken);

    // Its pending copy goes in the same update the message shows or is
    // patched in (see handleInstantPubnubPublishMessage); deleted locally first.
    await deleteTempMessageData(temp_timetoken);
    const removeTemp = () => dispatch({ type: actionTypes.REMOVE_TEMP_MESSAGE, payload: temp_timetoken });

    if (pnId !== activePnId) {
      removeTemp();
      return;
    }

    const alreadyConfirmed = currentMessageList.some(
      m => m.temp_timetoken === temp_timetoken || +m.timetoken === +timetoken
    );

    if (alreadyConfirmed) {
      const existingMsg = currentMessageList.find(
        m => m.temp_timetoken === temp_timetoken || +m.timetoken === +timetoken
      );
      const patch = {
        timetoken: +timetoken,
        id: messageId,
        ...(thread_number != null && { thread_number }),
      };
      dispatch({
        type: actionTypes.UPDATE_EXISTING_MESSAGE_LIST,
        payload: patch,
      });
      removeTemp();
      if (existingMsg) {
        await storeMessageToDb([{ ...existingMsg, ...patch }]);
      }
      return;
    }

    if (!tempMsg) {
      // The conversation-message PubNub event already delivered this message
      // (deleting the temp entry) before this signal arrived. The stale messageList
      // closure made alreadyConfirmed=false, so we patch the message in place using
      // the confirmed timetoken — the reducer uses current state, not the closure.
      removeTemp();
      if (thread_number != null && timetoken) {
        const patch = { timetoken: +timetoken, id: messageId, thread_number };
        dispatch({ type: actionTypes.UPDATE_EXISTING_MESSAGE_LIST, payload: patch });
        await updateMessageToDb(pnId, temp_timetoken, { thread_number, id: messageId });
      }
      return;
    }

    const confirmedFullMsg = {
      ...tempMsg,
      id: messageId,
      timetoken: +timetoken,
      createdAt,
      ...(thread_number != null && { thread_number }),
    };
    dispatch({ type: actionTypes.RECEIVED_GROUP_INSTANT_MESSAGE_LIST, payload: confirmedFullMsg });
    removeTemp();
    await storeMessageToDb([confirmedFullMsg]);
  };

export const handleFetchOldMessage =
  (pnId, topic_id, startFrom, subtopicId = "") => async (dispatch) => {
    let messageData = await getMessageFromDb(pnId, topic_id, startFrom, 50);
    if (subtopicId) {
      messageData = messageData.filter((m) => m.subtopic_id === subtopicId);
    }
    dispatch({
      type: actionTypes.RECEIVED_OLD_MESSAGE_LIST,
      payload: messageData,
    });
    return messageData;
  };

// A chat's stored messages are kept free of gaps. Live messages are stored for
// every chat, open or not, so syncing only what was newer than the newest
// stored message skipped everything missed before it (tab closed, offline),
// as did a sync cut short, and that history stayed missing until IndexedDB was
// cleared. Instead, opening a chat fetches its newest page and, if that doesn't
// reach back to where the chat was last known complete (chatSync), up to
// SYNC_GAP_PAGES older ones; if it still doesn't, the older stored messages
// are dropped (scrolling up loads them from the server again). Nothing is
// written if a request fails. Returns whether it synced.
const SYNC_PAGE_SIZE = 50;
const SYNC_GAP_PAGES = 4;

const syncChatMessages = async (pnId, payload, abortSignal) => {
  const pageOf = (res) =>
    (res.messages || [])
      .filter((m) => m?.timetoken > 0)
      .sort((a, b) => a.timetoken - b.timetoken);
  const latest = await getMessagesFromAPI({ pnId, payload, page_size: SYNC_PAGE_SIZE, abortSignal });
  if (!latest) return false;
  let fetched = pageOf(latest);
  let reachedStart = (latest.messages || []).length < SYNC_PAGE_SIZE;
  const syncedTo = await getChatSyncedTo(pnId);
  for (let i = 0; i < SYNC_GAP_PAGES && !reachedStart && syncedTo && fetched[0]?.timetoken > syncedTo; i++) {
    const older = await getMessagesFromAPI({
      pnId,
      payload,
      before_timetoken: fetched[0].timetoken,
      page_size: SYNC_PAGE_SIZE,
      abortSignal,
    });
    if (!older) return false;
    reachedStart = (older.messages || []).length < SYNC_PAGE_SIZE;
    fetched = [...pageOf(older), ...fetched];
  }
  const oldest = fetched[0]?.timetoken;
  if (reachedStart || !syncedTo || oldest > syncedTo) {
    await deleteMessagesBefore(pnId, oldest);
  }
  await storeMessageToDb(fetched);
  await setChatSyncedTo(pnId, fetched[fetched.length - 1]?.timetoken);
  return true;
};

// The messages last shown in each chat's main view (this tab, least recent
// first): going back to a chat shows them at once, without the loader, before
// the stored and server copies are read.
const shownMessages = new Map();
const SHOWN_CHATS_MAX = 30;
const rememberShown = (pnId, messages) => {
  shownMessages.delete(pnId);
  shownMessages.set(pnId, messages);
  if (shownMessages.size > SHOWN_CHATS_MAX) {
    shownMessages.delete(shownMessages.keys().next().value);
  }
};
// Another account's chats (on switching).
export const forgetShownMessages = () => shownMessages.clear();

// Only the latest handleFetchMessages call shows what it loads: an earlier one
// still loading (a chat or topic since left) doesn't replace it.
let latestFetchId = 0;

export const handleFetchMessages =
  (pnId, topic_id, payload = {}, callback, abortSignal) =>
    async (dispatch, getState) => {
      const fetchId = ++latestFetchId;
      const show = (messages) => {
        if (fetchId !== latestFetchId) return;
        dispatch({ type: actionTypes.RECEIVED_GROUP_MESSAGE_LIST, payload: messages });
      };
      try {
        const subtopicId = payload?.subtopicId || "";

        if (!topic_id && !subtopicId) {
          const remembered = shownMessages.get(pnId);
          if (remembered) {
            show(remembered);
            callback?.();
          }
          const stored = await getMessageFromDb(pnId, null);
          if (stored.length > 0 || !remembered) {
            show(stored);
          }
          if (stored.length > 0) {
            rememberShown(pnId, stored);
            callback?.();
          }
          if (await syncChatMessages(pnId, payload, abortSignal)) {
            const synced = await getMessageFromDb(pnId, null);
            rememberShown(pnId, synced);
            // Nothing new (e.g. a re-sync after reconnecting): update what's
            // shown in place, keeping older messages loaded by scrolling up.
            const onScreen = getState()?.arkchatgroup?.messageList || [];
            const onScreenTokens = new Set(onScreen.map((m) => m.timetoken));
            const unchanged =
              synced.length > 0 &&
              synced.every((m) => onScreenTokens.has(m.timetoken)) &&
              onScreen[onScreen.length - 1]?.timetoken === synced[synced.length - 1]?.timetoken;
            if (!unchanged) {
              show(synced);
            } else if (fetchId === latestFetchId) {
              dispatch({ type: actionTypes.MERGE_MESSAGE_LIST, payload: { messages: synced } });
            }
          }
        } else {
          // A topic's or subtopic's messages: shown from the server and not
          // stored (the store holds whole chats; a topic-only page in it read
          // as missing messages in the chat's main view).
          let stored = await getMessageFromDb(pnId, topic_id);
          if (subtopicId) {
            stored = stored.filter((m) => m.subtopic_id === subtopicId);
          }
          show(stored);
          if (stored.length > 0) {
            callback?.();
          }
          const res = await getMessagesFromAPI({
            pnId,
            payload: topic_id ? { ...payload, topicId: payload?.topicId || topic_id } : payload,
            abortSignal,
          });
          if (res) {
            let page = (res.messages || []).slice().sort((a, b) => a.timetoken - b.timetoken);
            if (subtopicId) {
              page = page.filter((m) => m.subtopic_id === subtopicId);
            }
            show(page);
          }
        }

        // The pending list isn't filtered by group when rendered, so only
        // replace it if this group is still the open one.
        const remainingTempMsgs = await pruneConfirmedTempMessages(pnId);
        if (remainingTempMsgs && getState()?.appStateData?.selectedGroupData?.pnId === pnId) {
          dispatch({ type: actionTypes.RECEIVED_TEMP_MESSAGE_LIST, payload: remainingTempMsgs });
        }

        callback?.();
      } catch (err) {
        callback?.();
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      }
    };

export const handleTaskUpdate = (reqBoby, task_id) => async (dispatch) => {
  try {
    const responseData = await axios.put(
      `${process.env.REACT_APP_BASE_PATH}/chats/task/${task_id}`,
      reqBoby,
      headerRequest(),
    );
    return responseData;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const getAttachments = (queryParam) => async (dispatch) => {
  try {
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/chats/attachment/${queryParam}`,
      headerRequest(),
    );
    dispatch({
      type: actionTypes.RECEIVED_ALL_ATTACHMENTS,
      payload: responseData?.data?.data,
    });
    return responseData?.data?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleUpdateMsgToDb =
  (reqBoby, shouldUpdateMessageList) => async (dispatch) => {
    try {
      const { pnId, temp_timetoken } = reqBoby;

      await updateMessageToDb(pnId, temp_timetoken, reqBoby, true);
    } catch (error) { }
  };

export const handleDeleteMsgFromDb =
  (
    msgPnId,
    temp_timetoken,
    sid,
    activePnId,
    activeTopicId,
    msglength,
    shouldUpdateMessageList,
  ) =>
    async (dispatch, getState) => {
      const isThreadScreen = session.get("isThreadScreen");
      // Resolves to whether the chat list may show something else now: the
      // message was the chat's latest (its preview) or still unread by me
      // (its badge). Unknown (not stored here) counts as yes.
      let affectsChatList = true;
      try {
        if (isThreadScreen) {
          dispatch({
            type: actionTypes.DELETE_EXISTING_THREAD_MESSAGE,
            payload: temp_timetoken,
          });
        }
        // Read it before it's removed from the local store.
        const msg = await getMessageByTempTimetoken(temp_timetoken);
        const state = getState();
        const chat = [...(state?.arkchatgroup?.groupList || []), ...(state?.arkchatgroup?.archiveGroupList || [])]
          .find((item) => item?.pnId === msgPnId);
        const myId = state?.profile?.profileData?.data?.id;
        if (msg && +chat?.timetoken) {
          const wasLatest = +msg.timetoken >= +chat.timetoken;
          const wasUnreadByMe = String(msg.from?.id) !== String(myId) && !(msg.read_by || []).map(String).includes(String(myId));
          affectsChatList = wasLatest || wasUnreadByMe;
        }
        await deleteMsgFromDb(temp_timetoken);
        if (shouldUpdateMessageList) {
          dispatch({ type: actionTypes.REMOVE_FROM_MESSAGE_LIST, payload: temp_timetoken });
        }
      } catch (error) { }
      return affectsChatList;
    };

export const handleSyncStarMsgData =
  (
    pnId,
    temp_timetoken,
    activeTopicId,
    msglength,
    updatedData,
    shouldUpdateMessageList = true,
    shouldUpdateThreadMessageList = false,
  ) =>
    async (dispatch) => {
      try {
        const decryptedData = handleDecryptSingleMessageData(updatedData);
        if (shouldUpdateThreadMessageList) {
          dispatch({
            type: actionTypes.UPDATE_EXISTING_THREAD_MESSAGE,
            payload: decryptedData,
          });
        }
        await updateMessageToDb(pnId, temp_timetoken, decryptedData);
        if (shouldUpdateMessageList) {
          dispatch({
            type: actionTypes.MERGE_MESSAGE_LIST,
            payload: { messages: Array.isArray(decryptedData) ? decryptedData : [decryptedData] },
          });
        }
      } catch (error) { }
    };

export const handleStarMessage =
  (reqBoby, pnId, activeTopic, messageCountToget) => async (dispatch) => {
    const isThreadScreen = session.get("isThreadScreen");
    try {
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/chats/starred`,
        reqBoby,
        headerRequest(),
      );
      if (responseData?.data?.status) {
        dispatch(handleScrollToBottom(false));
        const { pn_id, updatedAt, ...restData } = responseData?.data?.data;
        // pnId, timetoken, activeTopicId, msglength, updatedData
        dispatch(
          handleSyncStarMsgData(
            pnId,
            // The local store is keyed by temp_timetoken (timetoken never matched).
            responseData?.data?.data?.temp_timetoken,
            activeTopic?.id,
            messageCountToget?.length,
            restData,
            true,
            isThreadScreen,
          ),
        );
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

// A message was starred/unstarred (by this user, on any device): reload the
// starred list if the Starred screen is open on that group.
export const handleRefreshOpenStarredList = (pnId) => (dispatch, getState) => {
  const { showStarMessage, selectedGroupData } = getState()?.appStateData || {};
  if (showStarMessage && pnId && selectedGroupData?.pnId === pnId) {
    dispatch(handleGetStarMessages(pnId));
  }
};

export const handleGetStarMessages =
  (pnId, page = 1, page_size = 50) =>
    async (dispatch) => {
      try {
        const responseData = await axios.get(
          `${process.env.REACT_APP_BASE_PATH}/chats/starred/${pnId}?page=${page}&page_size=${page_size}`,
          headerRequest(),
        );
        const starMsgData = handleDecryptMessageData(
          responseData?.data?.data?.messages,
        );
        dispatch({
          type: actionTypes.REQUEST_GET_ALLSTAR_MESSAGE,
          payload: { ...responseData?.data?.data, messages: starMsgData },
        });
        return { ...responseData?.data?.data, messages: starMsgData };
      } catch (err) {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      }
    };

export const handleDeleteGroupMessage =
  (msgDetail, isAll) => async (dispatch) => {
    try {
      const responseData = await axios.delete(
        `${process.env.REACT_APP_BASE_PATH}/chats/${msgDetail?.pnId}/${msgDetail?.temp_timetoken}?all=${isAll}`,
        headerRequest(),
      );
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const handleReOrderToipc = (body, group_id) => async () => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/group/topic/order/${group_id}`,
      body,
      headerRequest(),
    );
    return responseData;
  } catch (error) {

  }
};

export const handleMoveChatToAnotherTopic =
  (pn_id, pubnub_timetoken, topic_id) => async (dispatch) => {
    try {
      const reqBody = {
        topic_id: topic_id,
        subtopic_id: "",
      };
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/chats/conversation/${pn_id}/${pubnub_timetoken}`,
        reqBody,
        headerRequest(),
      );
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const handleMoveChatToSubtopic =
  (pn_id, pubnub_timetoken, topic_id, subtopic_id) => async (dispatch) => {
    try {
      const reqBody = { topic_id, subtopic_id };
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/chats/conversation/${pn_id}/${pubnub_timetoken}`,
        reqBody,
        headerRequest(),
      );
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const handleGetThreadMessage =
  (reqBody, page = 1, page_size = 50) => async (dispatch) => {
    try {
      const conversationid = reqBody?.thread_id
        ? reqBody?.thread_id
        : reqBody?.id;

      const responsedata = await axios.get(
        `${process.env.REACT_APP_BASE_PATH}/chats/conversation/${conversationid}?page=${page}&page_size=${page_size}`,
        headerRequest(),
      );

      const { data } = responsedata;

      // Page 1 is the initial open of a thread: replace the whole list, parent included.
      if (page === 1) {
        const decryptedMessageData = handleDecryptMessageData([
          data?.data?.parent,
          ...(data?.data?.messages || []),
        ]);

        dispatch({
          type: actionTypes.RECEIVED_THREAD_MESSAGES,
          payload: decryptedMessageData,
        });
        return data;
      }

      // Later pages are older-message loads triggered by scrolling up: append only
      // (the parent was already dispatched by the page-1 call).
      const decryptedOldMessageData = handleDecryptMessageData(
        data?.data?.messages || [],
      );
      dispatch({
        type: actionTypes.RECEIVED_OLD_THREAD_MESSAGES,
        payload: decryptedOldMessageData,
      });
      return data;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
      // Return null (not undefined) so callers can distinguish a transient
      // error from a genuine "no more messages" response and allow a retry.
      return null;
    }
  };

export const handleFetchGroupThreads =
  (groupId, page = 1, page_size = 50, search = "", topicId = "", subtopicId = "", starredOnly = false) =>
  async (dispatch) => {
    try {
      let queryParams = `page=${page}&page_size=${page_size}`;
      if (search) queryParams += `&search=${encodeURIComponent(search)}`;
      if (subtopicId) queryParams += `&subtopicId=${subtopicId}`;
      else if (topicId) queryParams += `&topicId=${topicId}`;
      if (starredOnly) queryParams += `&starred=true`;
      const responseData = await axios.get(
        `${process.env.REACT_APP_BASE_PATH}/chats/threads/${groupId}?${queryParams}`,
        headerRequest(),
      );
      return responseData?.data;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
      return null;
    }
  };

export const handleToggleThreadStar = (threadId) => async (dispatch) => {
  try {
    const responseData = await axios.put(
      `${process.env.REACT_APP_BASE_PATH}/chats/thread-starred/${threadId}`,
      {},
      headerRequest(),
    );
    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
    return null;
  }
};

export const handleRenameThread = (threadId, title) => async (dispatch) => {
  try {
    const responseData = await axios.patch(
      `${process.env.REACT_APP_BASE_PATH}/chats/thread-heading/${threadId}`,
      { title },
      headerRequest(),
    );
    if (responseData?.data?.status) {
      dispatch({
        type: actionTypes.UPDATE_THREAD_HEADING,
        payload: { id: threadId, thread_heading: title },
      });
    }
    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleInstantPubnubPublishThreadMessage =
  (
    reqBody,
    activepnId,
    topic_id,
    temp_timetoken,
    shouldStoreMsgDb = true,
    isThreadScrollToBottom,
    shouldDispatchInstant = false,
  ) =>
    async (dispatch) => {
      const isThreadScreen = session.get("isThreadScreen");
      // Its pending copy goes in the same update the reply shows (see
      // handleInstantPubnubPublishMessage).
      await deleteTempMessageData(temp_timetoken);
      if (reqBody[0]?.pnId === activepnId) {
        if (isThreadScreen && isThreadScrollToBottom === reqBody[0]?.thread_id) {
          dispatch(handleThreadScrollToBottom(reqBody[0]?.thread_id));
        }
        if (isThreadScrollToBottom !== reqBody[0]?.thread_id) {
          dispatch(handleThreadScrollToBottom(null));
        }
        dispatch({
          type: actionTypes.RECEIVED_GROUP_INSTANT_THREAD_MESSAGE_LIST,
          payload: reqBody[0],
        });

        if (isThreadScreen || reqBody[0]?.chain || shouldDispatchInstant) {
          dispatch({
            type: actionTypes.RECEIVED_GROUP_INSTANT_MESSAGE_LIST,
            payload: reqBody[0],
          });
        }
      }
      dispatch({ type: actionTypes.REMOVE_TEMP_MESSAGE, payload: temp_timetoken });
      shouldStoreMsgDb && (await storeMessageToDb(reqBody));
    };

export const handleReadAllMsg = (reqBody, shouldUpdateGrpList = true) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.post(
        `${process.env.REACT_APP_BASE_PATH}/chats/mark-as-read`,
        reqBody,
        headerRequest(),
      );
      if (shouldUpdateGrpList) {
        await updateGroupDMDataMsgCount(reqBody?.ref_id);
        const updateData = await getGroupDMListData();
        dispatch({
          type: actionTypes.RECEIVED_ALL_GROUP_SUCCESS,
          payload: updateData,
        });
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleEditFileName = (reqBody, id) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/chats/attachment-rename/${id}`,
      reqBody,
      headerRequest(),
    );
    return responseData;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleMediaDownload = (reqBody) => async (dispatch) => {
  const { location, action } = reqBody;

  try {
    const params = { location };

    if (action) {
      params.action = action;
    }

    // config
    const config = { params, ...(action === "download" && { responseType: "blob" }) };

    const response = await axios.get(`${process.env.REACT_APP_BASE_PATH}/chats/attachment-download`, config);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const handleSearchGroupByName = (filterdgroupList) => (dispatch) => {
  dispatch({
    type: actionTypes?.RECEIVED_GROUP_FILTER,
    payload: filterdgroupList,
  });
};

export const handleUpdateGroupListOrder =
  (reorderedGroupList) => (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_GROUP_LIST_ORDER,
      payload: reorderedGroupList,
    });
  };

//********************************* AI Related Fun ().  ********************************

export const handleGetAiSubTaskSuggestion = (reqBody) => async (dispatch) => {
  try {
    var responsedata = null;
    responsedata = await axios.post(
      `https://platform.arkchat.com/v2/ai/subtask`,
      reqBody,
      headerRequest(),
    );
    return responsedata?.data;
  } catch (err) {
    return err;
  }
};

export const handleGetAiHistory = (queryParam) => async (dispatch) => {
  try {
    var responsedata = null;
    responsedata = await axios.get(
      `https://platform.arkchat.com/v2/ai/history?action=${queryParam}`,
      headerRequest(),
    );
    return responsedata?.data;
  } catch (err) {
    return err;
  }
};
export const handleDeleteAiHistory = (queryParam) => async (dispatch) => {
  try {
    const responseData = await axios.delete(
      `https://platform.arkchat.com/v2/ai/history?action=${queryParam}`,
      headerRequest(),
    );

    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleStar_UnstarAiHistory = (query_id) => async (dispatch) => {
  try {
    const responseData = await axios.put(
      `${process.env.REACT_APP_BASE_PATH}/chats/ai/${query_id}`,
      {},
      headerRequest(),
    );

    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleAttachmentToAi = (reqBody) => async (dispatch) => {
  try {
    // Use FormData to match the curl format
    const formData = reqBody.file; // This should already be FormData from the component

    const responseData = await axios.post(
      `${REACT_APP_UPLOAD_PATH}`,
      formData,
      {
        headers: {
          "x-api-key": "andai_bHJ2e7KqLp8XrF5vYzT9dC3mN4sW6gA",
          "Content-Type": "multipart/form-data",
        },
      },
    );
    if (responseData?.status === 200) {
      // dispatch({
      //   type: actionTypes.GET_QUERY_ANSWER_DONE,
      //   payload: responseData?.data?.data,
      // });
      return responseData?.status;
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleQueryToAi = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/chats/ai`,
      reqBody,
      headerRequest(),
    );
    if (responseData?.data?.code === 200) {
      dispatch({
        type: actionTypes.GET_QUERY_ANSWER_DONE,
        payload: responseData?.data?.data,
      });
      return responseData?.data?.code;
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleUseHistoryQuery = (history_data) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_QUERY_ANSWER_DONE,
    payload: history_data,
  });
};

export const handleEditAnswer = (editdata) => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_EDIT_ANSWER_DONE,
    payload: editdata,
  });
};

export const clearCurrentAiSessionData = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_CURRENT_AI_SESSION_DATA,
  });
};

//************************** Task Tab Func().**************************

export const handleCheckShouldMainTaskComplete =
  (taskId) => async (dispatch) => {
    try {
      let responsedata = await axios.get(
        `${process.env.REACT_APP_BASE_PATH}/chats/task/${taskId}`,
        headerRequest(),
      );
      return responsedata?.data?.data;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const handleTaskStart = (task_id, reqBoby) => async (dispatch) => {
  try {
    // https://apptest.arkchat.com/v2/chats/task/4 patch
    const responseData = await axios.patch(
      `${process.env.REACT_APP_BASE_PATH}/chats/task/${task_id}`,
      reqBoby,
      headerRequest(),
    );
    if (responseData?.data?.status) {
      dispatch({
        type: actionTypes.UPDATE_EXISTING_TASKLIST_DATA,
        payload: responseData?.data?.data,
      });
      return true;
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
  return false;
};

export const handleArchiveTask = (msg_id, type) => async (dispatch) => {
  try {
    const responseData = await axios.put(
      `${process.env.REACT_APP_BASE_PATH}/chats/archive/${msg_id}`,
      {},
      headerRequest(),
    );
    if (responseData?.data?.status) {
      if (type === MessageType?.Task) {
        dispatch({
          type: actionTypes.UPDATE_EXISTING_TASK_LIST,
          payload: responseData?.data?.data,
        });
      } else if (type === MessageType?.Approval) {
        dispatch({
          type: actionTypes.UPDATE_EXISTING_APPROVALLIST_LIST,
          payload: responseData?.data?.data,
        });
      }
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

const getTaskDataFromAPI = async (
  queryParam = "",
  page = 1,
  page_size = 50,
) => {
  try {
    let url = `${process.env.REACT_APP_BASE_PATH}/chats/tasks?page=${page}&page_size=${page_size}`;
    if (queryParam) {
      url = `${process.env.REACT_APP_BASE_PATH}/chats/tasks?&${queryParam}&page=${page}&page_size=${page_size}`;
    }

    const responseData = await axios.get(url, headerRequest());

    const decryptedData = handleDecryptMessageData(
      responseData?.data?.data?.messages,
      true,
    );

    if (responseData.status === 200) {
      return { ...responseData?.data?.data, messages: decryptedData };
    }
  } catch (err) {
    // console.error("Background API call error:", err);
  }
};

export const fetchOldTaskTabDataFromApi =
  (queryParam, page, lastData) => async (dispatch) => {
    getTaskDataFromAPI(queryParam, page).then(async (res) => {
      const taskMsgData = res?.messages?.filter(
        (apiMessage) => apiMessage?.timetoken < lastData?.timetoken,
      );
      if (taskMsgData?.length > 0) {
        dispatch({
          type: actionTypes.RECEIVED_OLD_TASKLIST_DATA,
          payload: taskMsgData,
        });
      }
    });
  };

export const handleGetAllTaskList =
  (queryParam, page, lastData) => async (dispatch) => {
    try {
      var responsedata = null;
      if (page && lastData) {
        dispatch(fetchOldTaskTabDataFromApi(queryParam, page, lastData));
      } else {
        if (queryParam) {
          responsedata = await axios.get(
            `${process.env.REACT_APP_BASE_PATH}/chats/tasks?${queryParam}`,
            headerRequest(),
          );
          const decryptedData = handleDecryptMessageData(
            responsedata?.data?.data?.messages,
            true,
          );

          dispatch(handleLoading(false));

          dispatch({
            type: actionTypes?.RECEIVED_ALL_TASKLIST,
            payload: decryptedData,
          });
        } else {
          getTaskDataFromAPI().then(async (res) => {
            dispatch(handleLoading(false));
            dispatch({
              type: actionTypes.RECEIVED_ALL_TASKLIST,
              payload: res?.messages,
            });
          });
        }
      }
    } catch (err) {
      dispatch(handleLoading(false));
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const handleGetTaskReopenedHistory = (taskId) => async (dispatch) => {
  try {
    let responsedata = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/chats/tasks-reopen-history/${taskId}`,
      headerRequest(),
    );
    return responsedata?.data?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleGetTaskAnalytics = (queryParam, abortSignal) => async (dispatch) => {
  try {
    const requestOptions = { ...headerRequest() };
    if (abortSignal) {
      requestOptions.signal = abortSignal;
    }
    const responsedata = await axios.get(
      queryParam
        ? `${process.env.REACT_APP_BASE_PATH}/chats/tasks-analytics?${queryParam}`
        : `${process.env.REACT_APP_BASE_PATH}/chats/tasks-analytics`,
      requestOptions,
    );

    dispatch({
      type: actionTypes?.RECEIVED_ALL_TASKANALYTICS_DATA,
      payload: responsedata?.data?.data,
    });
  } catch (err) {
    if (axios.isCancel(err)) {
      //
    } else {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  }
};

//************************** Approval Tab Fun().**************************

const getApprovalDataFromAPI = async (
  queryParam = "",
  page = 1,
  page_size = 50,
) => {
  try {
    let url = `${process.env.REACT_APP_BASE_PATH}/chats/approvals?page=${page}&page_size=${page_size}`;
    if (queryParam) {
      url = `${process.env.REACT_APP_BASE_PATH}/chats/approvals?&${queryParam}&page=${page}&page_size=${page_size}`;
    }
    const responseData = await axios.get(url, headerRequest());
    const decryptedData = handleDecryptMessageData(
      responseData?.data?.data?.messages,
    );

    if (responseData.status === 200) {
      return { ...responseData?.data?.data, messages: decryptedData };
    }
  } catch (err) {
    // console.error("Background API call error:", err);
  }
};

export const fetchOldApprovalTabDataFromApi =
  (queryParam, page, lastData) => async (dispatch) => {
    getApprovalDataFromAPI(queryParam, page).then(async (res) => {
      const approvalMsgData = res?.messages?.filter(
        (apiMessage) => apiMessage?.timetoken < lastData?.timetoken,
      );
      if (approvalMsgData?.length > 0) {
        dispatch({
          type: actionTypes.RECEIVED_OLD_APPROVALLIST_DATA,
          payload: approvalMsgData,
        });
      }
    });
  };

export const handleGetAllApprovalList =
  (queryParam, page, lastData) => async (dispatch) => {
    try {
      var responsedata = null;
      if (page && lastData) {
        dispatch(fetchOldApprovalTabDataFromApi(queryParam, page, lastData));
      } else {
        if (queryParam) {
          responsedata = await axios.get(
            `${process.env.REACT_APP_BASE_PATH}/chats/approvals?${queryParam}`,
            headerRequest(),
          );
          const decryptedData = handleDecryptMessageData(
            responsedata?.data?.data?.messages,
            false,
            true,
          );
          dispatch(handleLoading(false));
          dispatch({
            type: actionTypes?.RECEIVED_ALL_APPROVALLIST,
            payload: decryptedData,
          });
        } else {
          getApprovalDataFromAPI().then((res) => {
            dispatch(handleLoading(false));
            dispatch({
              type: actionTypes?.RECEIVED_ALL_APPROVALLIST,
              payload: res?.messages,
            });
          });
        }
      }
    } catch (err) {
      dispatch(handleLoading(false));
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

// Decrypt a work-tracking item: chain recursively (like approval tab) + balah items (like task tab)
const decryptWorkTrackingItem = (item) => {
  if (!item) return item;
  const withChain = decryptApprovalTabData(item); // decrypts message + chain recursively
  return {
    ...withChain,
    balah: (withChain.balah || []).map((b) => ({
      ...b,
      message: msgEncrypter.decrypt(b.message, process.env.REACT_APP_ENC_KEY, b.kuncika),
      translations: safeDecryptJson(b.translations, process.env.REACT_APP_ENC_KEY, b.kuncika),
    })),
  };
};

export const handleGetWorkTrackingList =
  (queryParam, page, lastData) => async (dispatch) => {
    try {
      const url = queryParam
        ? `${process.env.REACT_APP_BASE_PATH}/chats/work-tracking?${queryParam}`
        : `${process.env.REACT_APP_BASE_PATH}/chats/work-tracking`;

      if (page && lastData) {
        const res = await axios.get(`${url}${queryParam ? "&" : "?"}page=${page}&page_size=50`, headerRequest());
        const decryptedData = res?.data?.data?.messages?.map(decryptWorkTrackingItem);
        const newItems = decryptedData?.filter((item) => item?.timetoken < lastData?.timetoken);
        if (newItems?.length > 0) {
          dispatch({ type: actionTypes?.RECEIVED_OLD_WORK_TRACKING_DATA, payload: newItems });
        }
        const threadParents = res?.data?.data?.threadParents;
        if (threadParents && Object.keys(threadParents).length > 0) {
          dispatch({ type: actionTypes?.MERGE_WORK_TRACKING_THREAD_PARENTS, payload: threadParents });
        }
      } else {
        const res = await axios.get(url, headerRequest());
        const decryptedData = res?.data?.data?.messages?.map(decryptWorkTrackingItem);
        dispatch(handleLoading(false));
        dispatch({ type: actionTypes?.RECEIVED_ALL_WORK_TRACKING_LIST, payload: decryptedData });
        const threadParents = res?.data?.data?.threadParents;
        if (threadParents && Object.keys(threadParents).length > 0) {
          dispatch({ type: actionTypes?.MERGE_WORK_TRACKING_THREAD_PARENTS, payload: threadParents });
        }
      }
    } catch (err) {
      dispatch(handleLoading(false));
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };

export const handleGetApprovalAnalytics = (queryParam, abortSignal) => async (dispatch) => {
  try {
    const requestOptions = { ...headerRequest() };
    if (abortSignal) {
      requestOptions.signal = abortSignal;
    }
    const responsedata = await axios.get(
      queryParam
        ? `${process.env.REACT_APP_BASE_PATH}/chats/approvals-analytics?${queryParam}`
        : `${process.env.REACT_APP_BASE_PATH}/chats/approvals-analytics`,
      requestOptions,
    );

    dispatch({
      type: actionTypes?.RECEIVED_ALL_APPROVALANALYTICS_DATA,
      payload: responsedata?.data?.data,
    });
  } catch (err) {
    if (axios.isCancel(err)) {
      //
    } else {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  }
};

// ************************** Post **************************

export const handleCreatePost = (reqBody) => async (dispatch) => {
  try {
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/post`,
      reqBody,
      attachmentheaderRequest(),
    );

    const { data } = responseData?.data;
    if (responseData?.data?.status) {
      dispatch({
        type: actionTypes.CREATE_POST_DONE,
        payload: data,
      });
    }
    return responseData;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleGetPostList = (subscriber_id) => async (dispatch) => {
  try {
    // https://dev-api01.arkchat.com/v1/chats/post/subscriber/22
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/post/subscriber/${subscriber_id}`,
      headerRequest(),
    );

    const { data } = responseData;
    if (data?.status) {
      dispatch({
        type: actionTypes.GET_ALL_POST_LIST_DONE,
        payload: data?.data,
      });
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleGetMyFeedPosts = (subscriber_id, feed) => async (dispatch) => {
  try {
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/post/subscriber/${subscriber_id}?feed=${feed}`,
      headerRequest(),
    );
    const { data } = responseData;
    if (data?.status) {
      dispatch({
        type: actionTypes.GET_MY_FEED_POSTS,
        payload: data?.data,
      });
    }
    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleDeletePost = (post_id) => async (dispatch) => {
  try {
    const responseData = await axios.delete(
      `${process.env.REACT_APP_BASE_PATH}/post/${post_id}`,
      headerRequest(),
    );

    return responseData?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleFetchPostList =
  ({
    page_size = 20,
    page = 1,
    draft,
    visibility,
    type,
    category,
    bookmark,
    search,
    fetchOld = false,
  }) =>
    async (dispatch) => {
      try {
        let baseUrl = `${process.env.REACT_APP_BASE_PATH}/post/posts`;

        const queryParams = [];

        if (page_size) {
          queryParams.push(`page_size=${page_size}`);
        }
        if (page) {
          queryParams.push(`page=${page}`);
        }
        if (draft !== undefined) {
          queryParams.push(`draft=${draft}`);
        }
        if (visibility) {
          queryParams.push(`visibility=${visibility}`);
        }
        if (bookmark) {
          queryParams.push(`bookmark=${bookmark}`);
        }
        if (search) {
          queryParams.push(`search=${search}`);
        }
        if (type) {
          queryParams.push(`type=${type}`);
        }
        if (category) {
          queryParams.push(`category=${category}`);
        }

        // Construct the final URL with query parameters
        if (queryParams.length > 0) {
          baseUrl += `?${queryParams.join("&")}`;
        }

        const responseData = await axios.get(baseUrl, headerRequest());

        const { data } = responseData;
        if (data?.status && !fetchOld) {
          dispatch({
            type: actionTypes.GET_ALL_POST_LIST_EXPLORE_DONE,
            payload: data?.data,
          });
        } else if (data?.status && fetchOld) {
          dispatch({
            type: actionTypes.GET_OLD_POST_DATA_EXPLORE_DONE,
            payload: data?.data,
          });
        }
      } catch (err) {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      }
    };

export const handleLikeUpdate = (type, id) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_POST_LIST_EXPLORE,
    payload: id,
  });
};

export const handleLikePost = (post_id) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/post/like/${post_id}`,
        {},
        headerRequest(),
      );
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleViewLikes = (post_id) => {
  return async (dispatch) => {
    try {
      // https://apptest.arkchat.com/v2/onboarding/user/profile/18
      // https://apptest.arkchat.com/v2/post/viewlike/3
      const responseData = await axios.get(
        `${process.env.REACT_APP_BASE_PATH}/post/viewlike/${post_id}`,
        headerRequest(),
      );
      const { data } = responseData?.data;
      if (responseData?.data?.status) {
        dispatch({
          type: actionTypes.GET_LIKE_USER_LIST,
          payload: data,
        });
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleBookmarkPost = (post_id) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/post/bookmark/${post_id}`,
        {},
        headerRequest(),
      );
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const getSellerTabPost = (queryParam) => async (dispatch) => {
  try {
    var responsedata = null;
    if (queryParam) {
      responsedata = await axios.get(
        `${process.env.REACT_APP_BASE_PATH}/post/sellers?${queryParam}`,
        headerRequest(),
      );
    } else {
      responsedata = await axios.get(
        `${process.env.REACT_APP_BASE_PATH}/post/sellers`,
        headerRequest(),
      );
    }
    const { data } = responsedata?.data;
    dispatch({
      type: actionTypes.GET_ALL_SELLER_TAB_POSTS,
      payload: data,
    });
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const sellerCollaborate = (post_id) => async (dispatch) => {
  try {
    let responsedata = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/post/collaborate/${post_id}`,
      headerRequest(),
    );
    return responsedata?.data;
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const sellerConnect = (post_id) => async (dispatch) => {
  try {
    var responsedata = null;
    responsedata = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/post/connect/${post_id}`,
      headerRequest(),
    );

    dispatch(showToastMsg(responsedata?.data?.message));
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

// ****************** Brand *****************

export const handleGetBrandList = () => async (dispatch) => {
  try {
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/post/brands`,
      headerRequest(),
    );

    const { data } = responseData;
    if (data?.status) {
      dispatch({
        type: actionTypes.GET_ALL_BRAND_LIST_DONE,
        payload: data?.data,
      });
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleAddBrand = (reqBody) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.post(
        `${process.env.REACT_APP_BASE_PATH}/post/brand`,
        reqBody,
        headerRequest(),
      );

      if (responseData?.data?.status) {
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleEditBrand = (reqBody, brand_id) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/post/brand/${brand_id}`,
        reqBody,
        headerRequest(),
      );

      if (responseData?.data?.status) {
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleDeleteBrand = (brand_id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BASE_PATH}/post/brand/${brand_id}`,
      headerRequest(),
    );
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

//************************** Artists **************************

export const handleGetArtistList = () => async (dispatch) => {
  try {
    const responseData = await axios.get(
      `${process.env.REACT_APP_BASE_PATH}/post/artists`,
      headerRequest(),
    );

    const { data } = responseData;
    if (data?.status) {
      dispatch({
        type: actionTypes.GET_ALL_ARTISTS_LIST_DONE,
        payload: data?.data,
      });
    }
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleAddArtist = (reqBody) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.post(
        `${process.env.REACT_APP_BASE_PATH}/post/artist`,
        reqBody,
        headerRequest(),
      );

      if (responseData?.data?.status) {
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleEditArtist = (reqBody, artist_id) => {
  return async (dispatch) => {
    try {
      const responseData = await axios.put(
        `${process.env.REACT_APP_BASE_PATH}/post/artist/${artist_id}`,
        reqBody,
        headerRequest(),
      );

      if (responseData?.data?.status) {
      }
      return responseData;
    } catch (err) {
      dispatch({ type: REQUEST_FAILED, payload: err?.response });
    }
  };
};

export const handleDeleteArtist = (artist_id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BASE_PATH}/post/artist/${artist_id}`,
      headerRequest(),
    );
  } catch (err) {
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
  }
};

export const handleEditCreatePost = (reqBody, post_id) => async (dispatch) => {
  try {
    dispatch(requestShowLoader());
    const responseData = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/post/${post_id}`,
      reqBody,
      headerRequest(),
    );
    dispatch(
      showToastMsg(
        responseData?.data?.message
          ? responseData?.data?.message
          : responseData?.message,
      ),
    );
    return responseData;
  } catch (err) {
    dispatch(requestHiderLoader());
    dispatch({ type: REQUEST_FAILED, payload: err?.response });
    throw err;
  }
};

// Task reordering action
export const handleReorderTaskList = (reorderedTaskList) => (dispatch) => {
  dispatch({
    type: actionTypes.REORDER_TASK_LIST,
    payload: reorderedTaskList,
  });
};
